import React, { useEffect, useState } from 'react';
import axios from "axios";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import './OrganizationJobTitlesView.css';

import { apiUrl } from '../../../utility/Connections';

import { Layout, Divider } from 'antd';
import LoadingOverlay from '../../../components/loadingOverlay/loadingOverlay';
import TableJobTitles from '../../../components/tableJobTitles/tableJobTitles';
import FormJobTitles from '../../../components/formJobTitles/formJobTitles';
import { getFromLocalStorage } from '../../../helpers/EncryptData';
import Search from '../../../components/search/search';
const { Content } = Layout;

const OrganizationJobTitlesView = () => {

    const [showLoading, setShowLoading] = useState(false);
    const [loadingText, setLoadingText] = useState(null);
    const [filteredDataJobTitles, setFilteredDataJobTitles] = useState([]);
    const [dataJobTitles, setDataJobTitles] = useState([]);
    const [orgId, setOrgId] = useState("");
    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        const current_org = getFromLocalStorage("current_org");
        if (current_org) {
            setOrgId(current_org.org_id);
            getJobTitles(current_org.org_id);
        }
    }, []);

    const getJobTitles = (orgId) => {
        setShowLoading(true);
        setLoadingText("Cargando cargos de la organización...")

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.get(`${apiUrl}/job-titles/get-job-titles/${orgId}/`, headers)
            .then(function (response) {
                const data = response.data;
                setDataJobTitles(data);
                setShowLoading(false);
                if (searchText) {
                    filterData(searchText, data)
                } else {
                    setFilteredDataJobTitles(data);
                }
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    }

    // Función para agregar un nuevo registro de cargo
    const addJobTitle = (newJobTitle) => {
        setShowLoading(true);
        setLoadingText("Agregando cargo...")

        const formData = new FormData();
        formData.append("jtt_org_id", orgId);
        formData.append("jtt_title", newJobTitle);

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.post(`${apiUrl}/job-titles/create-job-title/`, formData, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Correcto");
                getJobTitles(orgId);
                setShowLoading(false);
            })
            .catch(function (error) {
                showSwal(error, 0, "Error")
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    }

    // Función para editar el nombre de un cargo
    const handleInputChangeTable = (jtt_id, jobTitle) => {
        setShowLoading(true);
        setLoadingText("Guardando cargo...")

        const formData = new FormData();
        formData.append("jtt_id", jtt_id);
        formData.append("jtt_title", jobTitle);

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.put(`${apiUrl}/job-titles/update-job-title/`, formData, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Correcto");
                getJobTitles(orgId);
                setShowLoading(false);
            })
            .catch(function (error) {
                showSwal(error, 0, "Error")
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    };

    // Función para eliminar un registro de cargo
    const handleDeleteTable = (jtt_id) => {
        setShowLoading(true);
        setLoadingText("Eliminando cargo...")

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.delete(`${apiUrl}/job-titles/delete-job-title/${jtt_id}/`, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Correcto");
                getJobTitles(orgId);
                setShowLoading(false);
            })
            .catch(function (error) {
                showSwal(error, 0, "Error")
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    };

    const onSearch = (value) => {
        setSearchText(value)
        filterData(value, dataJobTitles)
    }

    const filterData = (value, data) => {
        if (value.trim() === "") {
            setFilteredDataJobTitles(data); // 🔄 Si está vacío, mostrar todo el array original
        } else {
            const filtered = data.filter(item =>
                item.jtt_title.toLowerCase().includes(value.toLowerCase())
            );
            setFilteredDataJobTitles(filtered);
        }
    }

    const showSwal = (text, type, title) => {
        let swalType = "";
        if (type === 0) {
            swalType = "error";
        }
        if (type === 1) {
            swalType = "warning";
        }
        if (type === 2) {
            swalType = "success";
        }
        withReactContent(Swal).fire({
            title: title,
            icon: swalType,
            text: text,
            confirmButtonColor: "#012E40",
            cancelButtonColor: "#FF4D4F",
        })
    }

    return <div className='main-container'>
        {
            showLoading && <LoadingOverlay text={loadingText} showProgress={false} progress={null} />
        }
        <Content className='main-subcontainer main-subcontainer-column'>
            <div className='layout-content'>
                <FormJobTitles addJobTitle={addJobTitle} />
            </div>
            <Divider />
            <div className='layout-content'>
                <Search onSearch={onSearch} />
                <br></br>
                <TableJobTitles data={filteredDataJobTitles} handleInputChange={handleInputChangeTable} handleDelete={handleDeleteTable} />
            </div>
        </Content>
    </div>
}

export default OrganizationJobTitlesView;